import Constants from 'Constants'

const GRADE_FOR_CERTIFICATE_SCAN = 10

// TODO: i18n
const descriptions = [
  {
    id: Constants.familyEducationCertRequestSubmissionType.PERSONAL,
    description: `<p>Вам необходимо приехать по адресу:</p><p class="mb-3"><span class="font-weight-medium">Москва, Хохловский пер. 4с1. </span>Ближайшая станция метро - Китай-город, выход №8. <a href="https://yandex.ru/maps/-/CDB2vKIo" target="_blank">Схема прохода на Яндекс.Картах.</a></p><p class="font-weight-medium mb-3">Приёмные часы с 10:00 до 16:00 в будние дни.</p><p>При себе иметь:</p><ul class="pl-3"><li>Паспорт</li><li>Свидетельство о рождении</li><li>Заявление на аттестацию</li><li>Договор</li></ul>`,
  },
  {
    id: Constants.familyEducationCertRequestSubmissionType.VIA_POST,
    description: `<p>Вам необходимо отправить нам письмо с оригиналами заявления и договора по адресу:</p><p class="font-weight-medium mb-3">109028, Москва, Хохловский пер. 4с1</p><p>Кому:</p><p class="font-weight-medium mb-3">ЧОУ ОО "МШСО", СО.</p><div class="text-attention mb-3"><p>Просим обратить внимание, что если письмо придет позже срока подачи документов в информационную систему Департамента образования г. Москвы, вы не сможете пройти аттестацию в выбранный период.</p></div>`,
  },
]

export default {
  getAllStepsValid(state) {
    return Object.values(state.validStatus).every((status) => status === true)
  },

  getSchedules(state) {
    return state.theRequestIsAvailable?.schedules
  },

  getSubmissionTypes(state) {
    return state.submissionTypes.map((type, i) => ({
      ...type,
      description: descriptions[i].description,
    }))
  },

  getMainRequiredTests(state) {
    return state.theRequestIsAvailable?.tests.filter(
      (test) =>
        test.group.id ===
        Constants.familyEducationCertificationTestGroup.MAIN_REQUIRED,
    )
  },

  getRequiredTests(state) {
    return state.theRequestIsAvailable?.tests
      .filter(
        (test) =>
          test.group.id ===
          Constants.familyEducationCertificationTestGroup.REQUIRED,
      )
      .sort((a, b) => a.subject.id - b.subject.id)
  },

  getOptionalTests(state) {
    return state.theRequestIsAvailable?.tests
      .filter(
        (test) =>
          test.group.id ===
          Constants.familyEducationCertificationTestGroup.OPTIONAL,
      )
      .sort((a, b) => a.subject.id - b.subject.id)
  },

  isRequestAvailable(state) {
    return Boolean(state.theRequestIsAvailable?.schedules?.length)
  },

  isRequestAlreadyApplied(state) {
    return Boolean(state.theRequest?.status)
  },

  getRequestStatus(state) {
    const {
      AWAITING_DOCUMENTS,
      TRANSIT_DOCUMENTS,
      RETURNED,
      DOCUMENTS_RECEIVED,
      READY_TO_GO,
      STARTED,
      DRAFT,
    } = Constants.familyEducationCertRequestStatus

    const statusId = state.theRequest?.status?.id

    return {
      canEditSendData:
        statusId === TRANSIT_DOCUMENTS || statusId === AWAITING_DOCUMENTS,
      returned: statusId === RETURNED,
      documentsReceived: statusId === DOCUMENTS_RECEIVED,
      readyToGo: statusId === READY_TO_GO,
      started: statusId === STARTED,
      draft: statusId === DRAFT,
      canDownloadDocs:
        statusId === TRANSIT_DOCUMENTS ||
        statusId === AWAITING_DOCUMENTS ||
        statusId === RETURNED ||
        statusId === DRAFT,
    }
  },

  isCertificateScanFileAvailable(state) {
    return state.theRequestIsAvailable.grade?.id === GRADE_FOR_CERTIFICATE_SCAN
  },
}
